import { render, staticRenderFns } from "./VFormItemPhoto .vue?vue&type=template&id=04e76d8b&"
import script from "./VFormItemPhoto .vue?vue&type=script&lang=js&"
export * from "./VFormItemPhoto .vue?vue&type=script&lang=js&"
import style0 from "./VFormItemPhoto .vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports